import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'TimeOfFlight'
})

export class TimeOfFlight implements PipeTransform {
  transform(value: any, ...args: any[]): any {

    const time = value.split(':')[0];
    const min = value.split(':')[1];
    let day = time.split('.');
    if (day.length > 1) { // Tiene día
      day = `${day[0]}d ${day[1]}h`;
    } else {
      day = `${day[0]}h`;
    }
    return `${day} ${min}m`;
  }
}
